import { Trans } from "@lingui/macro";
import { UiBox, UiButton, UiDialogResponsive, UiTypography } from "@smp/ui";
import { FC, useCallback } from "react";

import { ConfirmComponentProps } from "@/context/confirm_component";

export const DialogRemoveAgentConfirmation: FC<
  ConfirmComponentProps<
    {
      idx?: number;
    },
    "ok" | "cancel"
  >
> = ({ idx, isOpen, resolve, close }) => {
  const handleClose = useCallback(() => {
    close();
    resolve("cancel");
  }, [close, resolve]);

  return (
    <UiDialogResponsive
      onClose={handleClose}
      open={isOpen}
      fullWidth
      maxWidth={480}
      isSmallPadding
      actionsLeft={[
        <UiButton color="paper" size="large" onClick={handleClose}>
          <Trans>Cancel</Trans>
        </UiButton>,
      ]}
      actionsRight={[
        <UiButton
          color="secondary"
          variant="outfill"
          size="large"
          onClick={() => resolve("ok")}
        >
          {<Trans>Delete</Trans>}
        </UiButton>,
      ]}
      title={<Trans>Delete Preset settings {idx}</Trans>}
    >
      <UiBox mt={2}>
        <UiTypography variant="body2">
          <Trans>Do you really want to delete this preset settings?</Trans>
        </UiTypography>

        <UiTypography variant="body2">
          <Trans>This action is irreversible.</Trans>
        </UiTypography>

        <UiTypography variant="body2">
          <Trans>The posts created with its help will not be deleted.</Trans>
        </UiTypography>
      </UiBox>
    </UiDialogResponsive>
  );
};
